<template>
    <div class="view" :style="{paddingTop:barh(0)}">
        <div class="content">
            <my-top title="审批" lefttext="" :arrow="false"></my-top>

            <van-cell-group title="基本信息">
              <van-cell title="所属分公司" :value="scoreData.branchCompany" />
              <van-cell title="所属项目" :value="scoreData.projectName" />
              <van-cell title="已返还金额（万元）" :value="scoreData.returnedAmount" />
              <van-cell title="预留风险金（万元）" :value="scoreData.reservedRiskFund" />
              <van-cell title="本次申请项目部人员风险金返还（%）" :value="scoreData.returnRatio" />
              <van-cell title="依据《商务管理手册》，项目部已完成（具体事项）" :label="scoreData.completedThings" />
              <van-cell title="填报人" :value="scoreData.creatorName" />
              <van-cell title="填报时间" :value="scoreData.createTime" />
              <van-cell title="附件"></van-cell>
              <div class="file-list" v-for="(item, index) in scoreData.fileInfoVOList" :key="item.id">
                <h5Download :fileInfo="item"></h5Download>
                <!-- <a class="file-item"
                    :href="downUrl(item.fileId)"
                    download
                >{{ item.fileName + item.suffixName }}</a> -->
              </div>
            </van-cell-group>

            <van-cell-group v-if="taskDefKey == 'GS_SWGLBJL_AUDIT'" title="公司财务资金部">
              <van-cell title="核定预留风险金(万元)" :value="scoreData.financeAudit && scoreData.financeAudit.approveAmount" />
              <van-cell title="其中，已转抵 (万元)" :value="scoreData.financeAudit && scoreData.financeAudit.creditedAmount" />
              <van-cell title="本次应返还(万元)" :value="scoreData.financeAudit && scoreData.financeAudit.returnAmount" />
              <van-cell title="审批意见" />
              <van-field
                class="msg-textarea"
                v-model="financeOpinions"
                rows="3"
                placeholder="请输入审批意见"
                show-word-limit
                type="textarea"
                maxlength="300"
                :disabled="true"
              />
            </van-cell-group>

            <!-- <h1 class="card-title">{{ processName }}</h1>
            <van-cell title-class="cell-title" title="节点信息" :value="taskName" />
            <van-cell title-class="cell-title" title="审批人" :value="userInfo && userInfo.name ? userInfo.name : ''" />
            <van-cell title-class="cell-title" title="审批时间" :value="currentTime" /> -->

            <van-form ref="financeForm" v-if="taskDefKey == 'GS_CWZJBJL_AUDIT'">
              <h1 class="card-title">公司财务资金部</h1>
              <van-field
                class="msg-textarea"
                v-model="financeAudit.approveAmount"
                type="number"
                label="核定预留风险金(万元)"
                placeholder="请输入"
                :show-error="false"
                :show-error-message="'false'"
                :required="financeRequired"
                :rules="[{ required: financeRequired }]"
                :disabled="(active !== 'todo')"
              />
              <van-field
                class="msg-textarea"
                v-model="financeAudit.creditedAmount"
                type="number"
                label="其中，已转抵 (万元)"
                placeholder="请输入"
                :show-error="false"
                :show-error-message="'false'"
                :required="financeRequired"
                :rules="[{ required: financeRequired }]"
                :disabled="(active !== 'todo')"
              />
              <van-field
                class="msg-textarea"
                v-model="financeAudit.returnAmount"
                type="number"
                label="本次应返还(万元)"
                placeholder="请输入"
                :show-error="false"
                :show-error-message="'false'"
                :required="financeRequired"
                :rules="[{ required: financeRequired }]"
                :disabled="(active !== 'todo')"
              />
            </van-form>

            <van-form ref="commercialForm" v-if="taskDefKey == 'GS_SWGLBJL_AUDIT'">
              <h1 class="card-title">公司商务管理部</h1>
              <van-cell title="该项目部人员所预留风险金符合《商务管理手册》有关返还条件，建议本次返还预留风险金"/>
                <van-field
                  class="msg-textarea"
                  v-model="commercialAudit.reserveReturnRatio"
                  type="number"
                  placeholder="请输入"
                  :required="commercialRequired"
                  :rules="[{ required: commercialRequired }]"
                  :show-error="false"
                  :show-error-message="'false'"
                  :disabled="(active !== 'todo')"
                >
                  <template #button>%</template>
                </van-field>
                <van-field
                  class="msg-textarea"
                  v-model="commercialAudit.reserveReturnAmount"
                  type="number"
                  placeholder="请输入"
                  :required="commercialRequired"
                  :rules="[{ required: commercialRequired }]"
                  :show-error="false"
                  :show-error-message="'false'"
                  :disabled="(active !== 'todo')"
                >
                  <template #button>万元</template>
                </van-field>
            </van-form>
            <!-- 通用审批表单 start -->
            <baseForm ref="baseForm"
              :opinion="curopinion"
              :onValid="onValid"
              :beforeSub="onSubmit"
              :btnGroup="btns"
            ></baseForm>
            <!-- 通用审批表单 end -->

            <!-- 审批流程信息start  -->
            <h1 class="card-title">审批流程信息</h1>
            <flowList :procInstId="procInstId"></flowList>
              <!-- 审批流程信息end  -->
        </div>
    </div>
</template>

<script>
    import { Dialog, Button, Toast, CellGroup , Cell } from 'vant';
    import application from '@api/application';
    import baseForm from './baseForm.vue'
    import flowList from './flowList.vue'
    import scoreForm from './scoreForm.vue'
    import h5Download from '@/components/download/download.vue'
    export default {
        name:'mattersDetail',
        components: { baseForm, scoreForm, flowList, h5Download, Dialog, Button, Toast, CellGroup , Cell },
        data() {
            return {
              next: false,
              rules: [{ required: true }],
              btnLoading: {
                scoreBtn: false,
                approval: false,
                unUpproval: false
              },
              scoreData: {},
              btns: {
                no: '驳回',
                ok: '通过'
                // other: '提交审批结果'
              },
              reportingTypeMap: {
                '0': '计划内填报',
                '1': '计划外填报'
              },
              financeRequired: false,
              commercialRequired: false,
              financeAudit: {
                approveAmount: '',
                creditedAmount: '',
                returnAmount: '',
                financeOpinions: ''
              },
              commercialAudit: {
                reserveReturnRatio: '',
                reserveReturnAmount: '',
                commercialOpinions: ''
              },
              opinions: '',
              businessId: '', // 指定业务ID
              procInstId: '', //当前流程实例ID
              taskId: '', //当前流程节点ID
              processName: '', //流程名称
              taskName: '', //当前流程节点名称
              taskDefKey: '', //任务标识
              currentTime: '', //当前审批时间
              currentUser: '', //当前审批人
              flowRequesting: false,
              detailUrl: null, //详情地址

              assignType: '', //节点类型   0 变量获取 1 处理人 2 候选人 3 候选组 4 会签
              assignCode: '', //候选组编码 岗位编码
              assignLevel: '', //层级 项目部 PD 分公司 BC 公司 CO
              businessType: '' //业务类型 0 项目
            }
        },
        created(){
          const { type, code, level, btype, businessId, procInstId, name, processName, detailUrl, taskId, taskDefKey, opinions } = this.$route.query
          if (type) {
              this.assignType = type
              this.assignCode = code
              this.assignLevel = level
              this.businessType = btype
          }
          if (opinions) {
            this.opinions = opinions
          }
          this.businessId = businessId
          if (!this.businessId) {
              Toast('无指定业务ID，将自动关闭');
              setTimeout(() => {
                  this.toback()
              }, 1500)
              return
          }
          this.procInstId = procInstId
          this.taskName = decodeURIComponent(name)
          this.processName = decodeURIComponent(processName)
          if (detailUrl) {
              this.detailUrl = decodeURIComponent(detailUrl)
          }
          // else {
          //     this.detailUrl = '/process/auditBusinessDetail'
          // }
          this.taskId = taskId
          this.taskDefKey = taskDefKey
          this.currentTime = this.formatTime(new Date(), true)

          this.getDetail()
        },
        computed: {
          active() {
            return this.$route.query.active
          },
          userInfo() {
            return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
          },
          curopinion() {
            if (this.taskDefKey == 'GS_CWZJBJL_AUDIT') {
              return this.financeAudit.financeOpinions
            } else if (this.taskDefKey == 'GS_SWGLBJL_AUDIT') {
              return this.commercialAudit.commercialOpinions
            }
          },
          financeOpinions() {
            return (this.scoreData.financeAudit != null && this.scoreData.financeAudit.financeOpinions) ? this.scoreData.financeAudit.financeOpinions : ''
          }
        },
        methods: {
            onValid(flag) {
              let curform;
              if (this.taskDefKey == 'GS_CWZJBJL_AUDIT') {
                curform =  this.$refs.financeForm;
                this.financeRequired = !flag;
              } else if (this.taskDefKey == 'GS_SWGLBJL_AUDIT') {
                curform =  this.$refs.commercialForm;
                this.commercialRequired = !flag;
              }
              curform.resetValidation()
              return new Promise((resolve, reject) => {
                this.$nextTick(() => {
                  curform.validate().then((res) => {
                    if (!res) {
                      resolve()
                    } else {
                      reject()
                    }
                  }).catch(() => {
                    reject()
                  })
                })
              })
            },
            onSubmit(obj) {
              let {flag, param} = obj;
              var params;
              let func;
              if (this.taskDefKey == 'GS_CWZJBJL_AUDIT') {
                params = {
                  ...this.financeAudit
                };
                params.id = this.businessId;
                if (param) params.financeOpinions = param;
                func = application.financeAudit;
              } else if (this.taskDefKey == 'GS_SWGLBJL_AUDIT') {
                params = {
                  ...this.commercialAudit
                };
                params.id = this.businessId;
                if (param) params.commercialOpinions = param;
                func = application.commercialAudit;
              }
              return new Promise((resolve, reject) => {
                if (flag) { // 驳回
                  resolve()
                } else {
                  func(params).then((res) => {
                    if (res && res.code == '200') {
                      resolve()
                    } else {
                      reject()
                    }
                  }).catch(() => {
                    reject()
                  })
                }
              })
            },
            getDetail() {
              Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                loadingType: 'spinner',
              });
              application.fundReturn({ id: this.businessId }).then((res) => {
                Toast.clear()
                if (res && res.code == '200') {
                  let data = res.data;
                  this.scoreData = data;
                  if(data.commercialAudit) this.commercialAudit =  data.commercialAudit;
                  if(data.financeAudit) this.financeAudit =  data.financeAudit;
                  this.queryOrgByCurrentUser();
                }
              })
            },
            queryOrgByCurrentUser() {
              application.queryOrgByCurrentUser({ tagCodes: ['BC'] }).then((res) => {
                if (res) {
                  let data = res;
                  data.forEach((item, index) => {
                    if (item.orgId == this.scoreData.branchComId) {
                      this.$set(this.scoreData, 'branchCompany', item.orgName)
                      this.querProject(item.orgId)
                    }
                  })
                }
              })
            },
            querProject(branchComIds) {
              application.queryProject({ branchComIds: [branchComIds] }).then((res) => {
                if (res && res.code == '200') {
                  let data = res.data
                  data.forEach((item, index) => {
                    if (item.projectId == this.scoreData.projectId) {
                      this.$set(this.scoreData, 'projectName', item.projectName)
                    }
                  })
                }
              })
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
          .card-title {
            font-size: 1.4rem;
            font-weight: normal;
            padding: 1rem 1.6rem;
            color: #969799;
            background: #f7f8fa;
          }
          .file-list {
            padding: 1rem 1.6rem;
            .file-item {
              word-break: break-all;
              color: #1989fa;
            }
          }
          .msg-textarea {
            ::v-deep .van-field__value {
                color: #969799;
                background: #f7f8fa;
            }
            background: none;
          }
          ::v-deep .cell-title {
            width: 8rem;
            flex: none;
          }
          .btns {
            overflow: hidden;
            padding: 1rem 1.6rem;
            ::v-deep .van-button {
              border-radius: 0.4rem;
              float: right;
              margin-left: 1rem;
            }
          }
        }
    }

</style>
